import i18n from 'config/i18n';
import dayjs from 'dayjs';
import type { Dayjs } from 'dayjs';
import * as yup from 'yup';

import { getLocale } from 'utils/date';

const getSchema = () => {
  const t = i18n.getFixedT(getLocale(), 'common');

  return yup.object({
    deletePeriod: yup.boolean().default(() => true),
    endDate: yup
      .mixed<Dayjs>()
      .default(dayjs().startOf('day'))
      .test(
        'endDate-valid',
        () => t('invalidDate'),
        (v) => (v ? v.isValid() : false)
      ),
    endTime: yup
      .mixed<Dayjs>()
      .default(dayjs().startOf('day'))
      .test(
        'endTime-valid',
        () => t('invalidDate'),
        (v, ctx) => ctx.parent.deletePeriod || (v ? v.isValid() : false)
      )
  });
};

export default getSchema;
